import PerformerInfo from './PerformerInfo';
import { PerformerInfoProps, PerformerInfoValueProps } from './types';

export type { PerformerInfoProps, PerformerInfoValueProps };
export default PerformerInfo;
